module.exports = __webpack_public_path__ + "static/media/Jared-Parrish-Headshot.945f6c0d.jpg";